import Gift from 'redhotpie-shared-lib/models/gift';
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable, { ImmutableObject } from 'seamless-immutable';
import ChatMessage from 'redhotpie-shared-lib/models/chatMessage';

export interface IGiftAction {
  type: string;
  data?: any;
  message?: string | null;
}

export type GiftCategory = 'Fun' | 'Flirty' | 'Naughty';

export interface ISelectedGiftData {
  data: string;
  description: string;
  diamonds: number;
  giftId: number;
  imageUrl: string;
  level: number;
  name: string;
  price: number;
}

export interface IGiftState {
  giftsReceived: Gift[];
  selectedGiftData: ISelectedGiftData | null;
  selectedGiftMessage: ChatMessage | null;
  isLoadingGiftData: boolean;
  categories: GiftCategory[];
  replies: string[];
  giftsData: Gift[];
}

export default (state: ImmutableObject<IGiftState> = initialState.giftReducer, action: IGiftAction) => {
  switch (action.type) {
    case types.LOAD_GIFTS_RECEIVED_SUCCESS: {
      return state.set('giftsReceived', action.data);
    }

    case types.SELECT_GIFT_DATA: {
      return state.set('selectedGiftMessage', action.message || null).set('selectedGiftData', action.data);
    }
    case types.LOADING_GIFTS_DATA: {
      return state.set('isLoadingGiftData', true);
    }
    case types.LOAD_GIFT_CATEGORIES_DATA: {
      return state.set('categories', action.data);
    }
    case types.LOAD_GIFT_REPLIES_DATA: {
      return state.set('replies', action.data);
    }
    case types.LOAD_GIFTS_DATA: {
      return state.set('isLoadingGiftData', false).set('giftsData', action.data);
    }
    case types.USER_LOGOUT_SUCCESS: {
      return initialState.giftReducer;
    }
    default:
      return state;
  }
};
